import React from 'react';
import { Card, Row, Col, Statistic, Button, DatePicker, Space, Table, Tabs } from 'antd';
import { DownloadOutlined, BarChartOutlined } from '@ant-design/icons';
import {
  LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid,
  Tooltip, Legend, ResponsiveContainer
} from 'recharts';

const monthData = [
  { month: '10月', 流量GB: 2840, 收入万元: 8.6, 新增卡: 320 },
  { month: '11月', 流量GB: 3120, 收入万元: 9.4, 新增卡: 480 },
  { month: '12月', 流量GB: 3560, 收入万元: 10.8, 新增卡: 620 },
  { month: '1月', 流量GB: 3200, 收入万元: 9.8, 新增卡: 410 },
  { month: '2月', 流量GB: 2980, 收入万元: 8.9, 新增卡: 380 },
  { month: '3月', 流量GB: 4820, 收入万元: 12.86, 新增卡: 720 },
];

const cardLifeData = [
  { key: '1', status: '测试期', count: 1240, rate: '2.5%' },
  { key: '2', status: '正常激活', count: 38240, rate: '76.5%' },
  { key: '3', status: '停机', count: 2650, rate: '5.3%' },
  { key: '4', status: '离线', count: 7820, rate: '15.6%' },
  { key: '5', status: '注销', count: 50, rate: '0.1%' },
];

const Report: React.FC = () => {
  const tabItems = [
    {
      key: 'traffic',
      label: '流量报表',
      children: (
        <div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
            <Space>
              <DatePicker.RangePicker />
              <Button icon={<DownloadOutlined />}>导出Excel</Button>
              <Button icon={<DownloadOutlined />}>导出PDF</Button>
            </Space>
          </div>
          <ResponsiveContainer width="100%" height={280}>
            <BarChart data={monthData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="流量GB" fill="#1890ff" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )
    },
    {
      key: 'revenue',
      label: '收入报表',
      children: (
        <div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
            <Button icon={<DownloadOutlined />}>导出</Button>
          </div>
          <ResponsiveContainer width="100%" height={280}>
            <LineChart data={monthData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line type="monotone" dataKey="收入万元" stroke="#52c41a" strokeWidth={2} dot={{ r: 5 }} />
              <Line type="monotone" dataKey="新增卡" stroke="#fa8c16" strokeWidth={2} dot={{ r: 5 }} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )
    },
    {
      key: 'lifecycle',
      label: '卡生命周期',
      children: (
        <Table
          dataSource={cardLifeData}
          size="small"
          pagination={false}
          columns={[
            { title: '状态', dataIndex: 'status', key: 'status' },
            { title: '数量', dataIndex: 'count', key: 'count', render: v => v.toLocaleString() },
            { title: '占比', dataIndex: 'rate', key: 'rate' },
          ]}
        />
      )
    }
  ];

  return (
    <div style={{ padding: 16 }}>
      <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
        {[
          { title: '本月总流量', value: '4.82TB' }, { title: '本月收入', value: '¥128,600' },
          { title: '本月新增卡', value: '720张' }, { title: '累计总卡数', value: '50,000张' },
        ].map((item, i) => (
          <Col span={6} key={i}>
            <Card bordered={false} style={{ borderRadius: 8 }}>
              <Statistic title={item.title} value={item.value} valueStyle={{ fontWeight: 700, fontSize: 20 }} />
            </Card>
          </Col>
        ))}
      </Row>
      <Card
        title={<span><BarChartOutlined /> 报表中心</span>}
        bordered={false}
        style={{ borderRadius: 8 }}
      >
        <Tabs items={tabItems} />
      </Card>
    </div>
  );
};

export default Report;
